module.exports = __webpack_public_path__ + "static/media/What-Content-Marketers-Need-to-Know-About-the-Metaverse.3afe6a3b.jpeg";